import React from "react"
import { Supplier } from "../../interfaces/supplier"
import { MultiSelect } from "./MultiSelect"
import { MenuPlacement } from "react-select"

export const SuppliersList = ({
  selected,
  onSelect,
  multiple,
  isClearable,
  menuPlacement,
}: {
  selected?: number[]
  onSelect: Function
  multiple?: boolean
  isClearable?: boolean
  menuPlacement?: MenuPlacement
}) => {
  return (
    <MultiSelect
      menuPlacement={menuPlacement}
      isClearable={isClearable}
      selected={selected}
      onSelect={onSelect}
      multiple={multiple}
      endpoint="suppliers"
      label={(supplier: Supplier) => supplier.name}
    />
  )
}
